<template>
  <div
    class="loading-indicator-wrapper"
    :class="enableMinDimensions && loading ? 'loading-indicator-wrapper--min-dimensions' : ''"
  >
    <loading-indicator
      v-if="loading"
      :dark="dark"
      :variant="variant"
      spinoff="in-relative-centered"
    />
    <slot />
  </div>
</template>

<script>
import LoadingIndicator from 'atoms/loading-indicator/LoadingIndicator';

export default {
  name: 'LoadingIndicatorWrapper',
  components: {
    LoadingIndicator,
  },
  props: {
    loading: {
      type: [Boolean, Number],
      required: true,
    },
    variant: {
      type: String,
      default: 'spinnerLocal',
    },
    dark: Boolean,
    enableMinDimensions: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './loading-indicator-wrapper';
</style>
